var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "my-1", attrs: { outlined: "" } },
    [
      _c(
        "v-row",
        {
          staticClass: "ma-0",
          attrs: { justify: "space-around", align: "center" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-column pa-2 py-2",
              staticStyle: { "min-width": "10rem" },
              attrs: { cols: "auto" },
            },
            [
              _c("span", {
                staticClass: "text-h6 font-weight-black",
                domProps: { textContent: _vm._s(_vm.pratica.documentNbr) },
              }),
              _c(
                "v-row",
                { staticClass: "ma-0", attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { staticClass: "py-0 text-caption" },
                    [
                      _c("ReadonlyField", {
                        attrs: {
                          label: _vm.$t("label.createDate"),
                          value: _vm.createDate,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "py-0 text-caption" },
                    [
                      _c("ReadonlyField", {
                        attrs: {
                          label: _vm.$t("label.updateDate"),
                          value: _vm.updateDate,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-col",
            { staticClass: "pa-1 d-flex align-center" },
            [
              _c(
                "v-row",
                {
                  staticClass: "ma-0",
                  staticStyle: { width: "100%" },
                  attrs: { dense: "" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 px-1",
                      staticStyle: {
                        "font-size": "0.85rem",
                        color: "rgba(0, 0, 0, 0.7)",
                        "font-weight": "500",
                      },
                    },
                    [
                      _c("ReadonlyField", {
                        attrs: {
                          label: _vm.$t("label.shipper"),
                          value: _vm.pratica.shipperName,
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "py-0 px-1",
                      staticStyle: {
                        "font-size": "0.85rem",
                        color: "rgba(0, 0, 0, 0.7)",
                        "font-weight": "500",
                      },
                    },
                    [
                      _c("ReadonlyField", {
                        attrs: {
                          label: _vm.$t("label.consignee"),
                          value: _vm.pratica.consigneeName,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-col",
            { staticClass: "pa-1 d-flex align-center justify-center" },
            [
              _c(
                "div",
                {
                  staticClass: "d-flex align-center",
                  staticStyle: {
                    gap: "0.5rem",
                    width: "100%",
                    "max-width": "32rem",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column align-center",
                      staticStyle: { "min-width": "7rem", "max-width": "9rem" },
                    },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticStyle: {
                            border: "2px solid var(--v-primary-base)",
                          },
                          attrs: { size: "36" },
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { size: "18", color: "primary" } },
                            [_vm._v("mdi-ferry")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "location-label",
                          attrs: { title: _vm.pratica.polLabel },
                        },
                        [_vm._v(" " + _vm._s(_vm.pratica.polLabel) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column align-center flex-grow-1",
                      staticStyle: { "min-width": "0" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "d-flex align-center",
                          staticStyle: { width: "100%" },
                        },
                        [
                          _c("v-divider"),
                          _c(
                            "v-icon",
                            {
                              staticStyle: { "flex-shrink": "0" },
                              attrs: { size: "12", color: "primary" },
                            },
                            [_vm._v("mdi-navigation-variant")]
                          ),
                          _c("v-divider"),
                        ],
                        1
                      ),
                      _vm.pratica.vesselName
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "vessel-name",
                              attrs: {
                                small: "",
                                color: "blue-grey lighten-5",
                                title: _vm.pratica.vesselName,
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.pratica.vesselName) + " ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-column align-center",
                      staticStyle: { "min-width": "7rem", "max-width": "9rem" },
                    },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticStyle: {
                            border: "2px solid var(--v-primary-base)",
                          },
                          attrs: { size: "36" },
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { size: "18", color: "primary" } },
                            [_vm._v("mdi-ferry")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "location-label",
                          attrs: { title: _vm.pratica.podLabel },
                        },
                        [_vm._v(" " + _vm._s(_vm.pratica.podLabel) + " ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c("v-divider", { attrs: { vertical: "" } }),
          _c(
            "v-col",
            {
              staticClass:
                "pa-2 d-flex flex-column align-center justify-center",
              staticStyle: { gap: "0.5rem", "min-width": "3rem" },
              attrs: { cols: "auto" },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", small: "", color: "grey darken-1" },
                  on: {
                    click: function ($event) {
                      _vm.expandTracking = !_vm.expandTracking
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.expandTracking
                          ? "mdi-chevron-up"
                          : "mdi-chevron-down"
                      )
                    ),
                  ]),
                ],
                1
              ),
              _vm.pratica.masterVisible
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "", color: "primary" },
                      on: { click: _vm.goToPratica },
                    },
                    [
                      _c("v-icon", { attrs: { small: "" } }, [
                        _vm._v("mdi-eye-outline"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { "no-gutters": "" } },
        [
          _c(
            "v-col",
            { staticClass: "pa-0", attrs: { cols: "12" } },
            [
              _vm.houseVisibilityAuth
                ? _c("HouseBLExtension", {
                    attrs: { open: _vm.expandTracking, houses: _vm.houses },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }